import React from 'react';
import { SkeletonBrick } from '@carnica/ui-kit';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const TariffSkeleton = () => (
  <div className={cn('wrapper')}>
    <SkeletonBrick className={cn('top')} height={20} width="100%" />
    <SkeletonBrick className={cn('top')} height={20} width="100%" />
    <SkeletonBrick className={cn('top')} height={20} width="100%" />
  </div>
);
